const initialState = {
  bulkReviews: [],
  review: '',
  checkAll: false,
  checked_id: 0,
  checked_type: '',
  checked: false,
  agendaResources: {}
}

export function bulkReviewsReducer(state = initialState, { type, payload }){
  switch(type){
    case "LOAD_RESOURCES":
      state.agendaResources = {
        ...state.agendaResources,
        ...payload
      }
      return {
        ...state,
        agendaResources: { ...state.agendaResources }
      }
    case "ADD_RESOURCE":
      return {
        ...state,
        bulkReviews: state.bulkReviews.concat(payload),
        checked_id: payload.resource_id,
        checked_type: payload.resource_type,
        checked: true,
        checkAll: (payload.resources_size === (state.bulkReviews.length + 1)) && payload.resources_size > 0
      }
    case "REMOVE_RESOURCE":
      return {
        ...state,
        bulkReviews: state.bulkReviews.filter(review => !(review['resource_id'] === payload['resource_id'] && review['resource_type'] === payload['resource_type'])),
        checkAll: payload.checkAll,
        checked_id: payload.resource_id,
        checked_type: payload.resource_type,
        checked: false
      }
    case "ADD_REVIEW":
      return {
        ...state,
        review: payload.review
      }
    case "SELECT_ALL":
      return {
        ...state,
        checkAll: true
      }
    case "UNSELECT_ALL":
      return {
        ...state,
        checkAll: false
      }
    default:
      return state
  }
}
  